import { useState } from 'react';
import { Grid } from '@mui/material';

import { leaveManageApiKeyStore } from '../../api/leave-manage-api-key-store';
import { SiTrackGrid } from '../../components/si-track-grid/si-track-grid';
import { approvalColumns } from './columns/approval-grid-columns';
import { EmployeeFilter } from './filters/employee.filter';
import { StatusFilter } from './filters/status.filter';
import { StartDateFilter } from './filters/start-date.filter';
import { EndDateFilter } from './filters/end-date.filter';
import { LeaveDetailsComponent } from './leave-details.component';
import { UserPermissionName } from '../../models/user-permission-name';
import { useCurrentUser } from '../../hooks/use-current-user';

export const LeaveApprovalComponent = () => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [leaveDetails, setLeaveDetails] = useState<any>();
  const [approvalProps, setApprovalProps] = useState<any>({
    leaveStatusID: 0,
    requestedBy: '',
    fromDate: '',
    toDate: '',
  });

  const onChange = (type: string, value: any) => {
    setApprovalProps((prevState: any) => ({
      ...prevState,
      [type]: value,
    }));
  };
  const handleViewLeave = (data: any) => {
    setLeaveDetails(data);
    setOpenDialog(!openDialog);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={2} sm={2} xl={2} xs={2}>
          <EmployeeFilter onChange={onChange} />
        </Grid>
        <Grid item lg={2} sm={2} xl={2} xs={2}>
          <StatusFilter onChange={onChange} />
        </Grid>
        <Grid item lg={2} sm={2} xl={2} xs={2}>
          <StartDateFilter onChange={onChange} />
        </Grid>
        <Grid item lg={2} sm={2} xl={2} xs={2}>
          <EndDateFilter onChange={onChange} />
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <SiTrackGrid
            fileTitle='leave_approval'
            dataItemKey="leaveID"
            columns={approvalColumns}
            queryConfig={leaveManageApiKeyStore.getLeaveApprovalList(approvalProps)}
            onView={handleViewLeave}
            actionPermissions={{
              view: UserPermissionName.VIEW_LEAVE,
              export: UserPermissionName.DOWNLOAD_GRID,
            }}
          />
        </Grid>
      </Grid>
      <LeaveDetailsComponent
        leaveDetails={leaveDetails}
        open={openDialog}
        config={{
          saveConfig: leaveManageApiKeyStore.processLevelRequest(),
          invalidateRoute: () => leaveManageApiKeyStore.getLeaveApprovalList(approvalProps),
        }}
        onClosed={() => setOpenDialog(!openDialog)}
      />
    </>
  );
};
